export default __webpack_public_path__ + "static/media/Bannerlast1.f0033713.png";